import { motion } from "framer-motion";
import { ChapterHead } from "./motion";
import { PHASES, IMAGES } from "./data";

export const Roadmap = () => (
  <section data-testid="chapter-roadmap" className="chapter-print-break bg-alt py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <ChapterHead
        num="04"
        title="Implementation Roadmap"
        sub="6–7 months from kickoff to stabilized operations. Operations first, finance last — Go-Live aligned to a fiscal period boundary."
      />
      <div className="relative">
        <div className="absolute top-0 bottom-0 left-4 w-px bg-line sm:left-1/2" />
        {PHASES.map((p, i) => (
          <motion.div
            key={p.phase}
            data-testid={`phase-item-${i}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className={`relative mb-14 pl-14 sm:w-1/2 sm:pl-0 ${
              i % 2 === 0 ? "sm:pr-14 sm:text-right" : "sm:ml-auto sm:pl-14"
            }`}
          >
            <span
              className={`absolute top-1 left-[9px] h-3.5 w-3.5 rotate-45 border-2 border-amber-500 bg-alt sm:left-auto ${
                i % 2 === 0 ? "sm:-right-[7px]" : "sm:-left-[7px]"
              }`}
            />
            <p className="font-mono2 text-[11px] tracking-[0.3em] text-accent uppercase">
              {p.phase} · {p.duration}
            </p>
            <h3 className="font-display mt-2 text-xl font-semibold text-ink sm:text-2xl">{p.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-ink4">{p.deliverable}</p>
          </motion.div>
        ))}
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative mt-4 overflow-hidden rounded-sm border border-line"
      >
        <img src={IMAGES.rig} alt="Offshore rig" className="h-56 w-full object-cover sm:h-72" />
        <div className="absolute inset-0 flex items-end bg-[#0b0f17]/55">
          <p className="font-mono2 px-6 py-4 text-[11px] tracking-[0.3em] text-amber-400 uppercase">
            Each phase ends with a stable, usable system — the business is never fully "down"
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
